import React from "react";
import { withTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";

import Footer from "../../Footer/FooterBottom";
import TracksBg from "./TracksBg";

class Tracks extends React.Component {

    state = { trackId: 1 };

    componentDidMount() {
        const { id } = this.props.match.params;

        this.setState({
            trackId: parseInt(id)
        });
    }

    static getDerivedStateFromProps(props, state) {
        const { id } = props.match.params;
        state.trackId = parseInt(id);
        return state;
    }


    render() {
        const { t } = this.props;

        return (
            <>
                <Helmet>
                    <title>
                        {this.state.trackId === 1 ? t('PageHeader.FirstTrack') : t('PageHeader.SecondTrack')}  | {t('alarabeyya')}
                    </title>
                </Helmet>
                <TracksBg
                    title={this.state.trackId === 1 ? t('PageHeader.FirstTrack') : t('PageHeader.SecondTrack')}
                    subTitle={t('PageHeader.MainType')}
                    onEdit={false}
                    trackId={this.state.trackId}
                    perfixUrl={""}
                />
                <div className="position-sticky">
                    <Footer />
                </div>
            </>
        );
    }
}

export default withTranslation('common')(Tracks);